<ion-header>
  <ion-toolbar>
    <ion-row>
      <ion-col size="3"></ion-col>
      <ion-col size="6">
        <div class="header">
          <img src="../../../../../assets/icon/logo.png" alt="logo" />
        </div>
      </ion-col>
      <ion-col size="3">
        <div class="header">
          <ion-menu-button  class="side-menu"></ion-menu-button>
        </div>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="homescreen-image">
    <div class="text flex">
      <div class="tag">
        <ion-text> It's Coffee Time </ion-text>
      </div>
      <div class="description">
        <span>
          Order ahead and earn reward points toward free drinks and beans. </span>
          <span>Tap to
          <span class="border-bottom" (click)="navigateToStoneCreekSite()">learn more.</span>
          </span>
         <p class="reward-text">View Your<span class="border-bottom" (click)="navigateToRewards()"> Points & Rewards.</span></p>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <div class="footer">
    <ion-row>
      <ion-text class="location">Location</ion-text>
      <div
        class="location-list"
        size="12"
        *ngIf="chosenRestaurant && currentRestaurantId"
        (click)="chooseLocationMobile()"
      >
        <ion-button expand="block" class="select-location">
          <div class="selected-location">
            <ion-col size="2">
              <div class="location-icon">
                <ion-icon name="pin" slot="start"></ion-icon>
              </div>
            </ion-col>
            <ion-col size="9" class="location-text">
              <ion-text class="location-name">{{
                chosenRestaurant.name
              }}</ion-text>
              <ion-text class="location-address">
                {{ chosenRestaurant.address.addressLine }}
              </ion-text>
            </ion-col>
            <ion-col size="1">
              <ion-icon name="md-arrow-dropdown"></ion-icon>
            </ion-col>
          </div>
        </ion-button>
      </div>

      <ion-col class="place-order" size="12" *ngIf="!cartStoreItems">
        <ion-button class="order-btn" expand="block" (click)="navigateToRestaurant()">
          Place An Order
        </ion-button>
      </ion-col>

      <ion-col class="Continue-order" size="9" *ngIf="cartStoreItems">
        <ion-button class="continue-btn" expand="block" (click)="navigateToRestaurant()">
          Continue Ordering
        </ion-button>
      </ion-col>

      <ion-col class="end-text" size="3" *ngIf="cartStoreItems">
        <ion-button class="cart-button" (click)="navigateToCheckout()">
          <ion-icon name="cart"></ion-icon>
          <ion-text>{{ cartStore.items.length }}</ion-text>
        </ion-button>
      </ion-col>
    </ion-row>
  </div>
</ion-footer>
